import { useAtomValue } from 'jotai'
import { useResetAtom } from 'jotai/utils'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ExecuteCancelDialog,
  type ExecuteCancelDialogProps,
} from '~/components/elements/ExecuteCancelDialog'
import { ensureExists } from '~/utils'

import { dialogInfoAtom } from '../atoms'
import { useCloseDialogWithRefresh } from '../hooks/useCloseDialogWithRefresh'
import { useDeleteSurveyGroupMutation } from '../hooks/useDeleteSurveyGroupMutation'

export const DeleteSurveyGroupDialog = () => {
  const { t } = useTranslation()
  const resetDialogInfo = useResetAtom(dialogInfoAtom)

  const closeDialogWithRefresh = useCloseDialogWithRefresh()
  const deleteSurveyGroupMutation = useDeleteSurveyGroupMutation({
    onSuccess: closeDialogWithRefresh,
  })
  const dialogInfo = useAtomValue(dialogInfoAtom)
  const surveyGroup = ensureExists(
    dialogInfo?.surveyGroup,
    t('assertion_failed'),
  )
  const handleExecute = React.useCallback<
    EH<ExecuteCancelDialogProps, 'onExecute'>
  >(() => {
    deleteSurveyGroupMutation.mutate(surveyGroup.id)
  }, [deleteSurveyGroupMutation, surveyGroup.id])

  return (
    <ExecuteCancelDialog
      executing={deleteSurveyGroupMutation.isPending}
      mode="delete"
      title={t('delete_survey_group')}
      onCancel={resetDialogInfo}
      onExecute={handleExecute}
    >
      {t('delete_confirmation', { target: surveyGroup.title })}
    </ExecuteCancelDialog>
  )
}
